module.exports = __webpack_public_path__ + "img/sky-box-01.69df4027.jpeg";